import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { selectColor } from '@panel/commons/core/theme';
import SectionLayout from '../../SectionLayout';
import { Container, HeaderArea, Icon, TitleText, TooltipComponent, IconTooltip } from './styles';
import IconConversion from '../../../assets/icons/conversionIcon.svg';
import TooltipHelper from '../../../assets/icons/tooltipHelper.svg';
import PyramidChart from '../../PyramidChart';
import EmptyStateCharts from '../../EmptyState';

const ConversionChart = ({ data, device, isStatisticsByPosting, error, reloadDispatch }) => {
  const { t } = useTranslation();

  const tooltipComponentHeader = () => {
    return (
      <TooltipComponent>
        {t(`panel.estadisticas.conversionChart.tooltip${isStatisticsByPosting ? '.singular' : ''}`)}
      </TooltipComponent>
    );
  };

  const getWidthSection = () => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '50%';
    return '68%';
  };

  return (
    <SectionLayout
      width={getWidthSection()}
      marginTop={device !== 'desktop' && 16}
      padding={device !== 'desktop' && 16}
    >
      <Container device={device} data={data} data-tour-panel='estadisticas-conversionChart'>
        <HeaderArea device={device} data-panel='panel-estadisticas-conversionChart-headerArea'>
          <Icon icon={IconConversion} data-panel='panel-estadisticas-conversionChart-icon' />
          <TitleText data-panel='panel-estadisticas-conversionChart-title'>
            {t('panel.estadisticas.conversionChart.title')}
          </TitleText>
          <SimpleTooltip
            offset={5}
            backgroundColor={selectColor('black')}
            isMobile={false}
            text={tooltipComponentHeader()}
            position='top-center'
            dataPanel='panel-estadisticas-conversionChart-tooltip'
            allowPlacements='top-end'
            autoPlacements
          >
            <IconTooltip
              src={TooltipHelper}
              alt='tooltip-helper'
              width='16'
              height='16'
              data-panel='panel-estadisticas-conversionChart-icon-tooltip'
            />
          </SimpleTooltip>
        </HeaderArea>
        {data && !error ? (
          <PyramidChart device={device} data={data} isStatisticsByPosting={isStatisticsByPosting} />
        ) : (
          <EmptyStateCharts withSpacing={device === 'desktop'} callback={reloadDispatch} />
        )}
      </Container>
    </SectionLayout>
  );
};

export default ConversionChart;
